import { categoryQueries } from './queries';
import { categoryMutations } from './mutations';
import type { 
  CreateCategoryParams, 
  DeleteCategoryParams, 
  UpdateCategoryParams, 
  UpdateCategoryOrderParams,
  Category,
  CategoryWithRelations
} from '@/features/categories/types';

// Define the service interface
export interface CategoryService {
  getCategories: (providerId: number, versionId: number) => Promise<CategoryWithRelations[]>;
  getCategoryHierarchy: (providerId: number, versionId: number) => Promise<CategoryWithRelations[]>;
  createCategory: (params: CreateCategoryParams) => Promise<Category>;
  updateCategory: (params: UpdateCategoryParams) => Promise<Category>;
  deleteCategory: (params: DeleteCategoryParams) => Promise<void>;
  updateDisplayOrder: (params: UpdateCategoryOrderParams) => Promise<void>;
}

// Add getCategoryHierarchy to categoryQueries
const extendedQueries = {
  ...categoryQueries,
  getCategoryHierarchy: async (providerId: number, versionId: number) => {
    return await categoryQueries.getCategoriesHierarchical(providerId, versionId);
  }
};

// Export individual parts for direct imports
export { extendedQueries as categoryQueries };
export { categoryMutations };

// Export default combined service
export const categoryService: CategoryService = {
  ...extendedQueries,
  ...categoryMutations,
  createCategory: async (params: CreateCategoryParams) => {
    const result = await categoryMutations.createCategory(params);
    return {
      ...result,
      provider_id: result.provider_id || 0
    } as Category;
  },
  updateCategory: async (params: UpdateCategoryParams) => {
    const result = await categoryMutations.updateCategory(params);
    return {
      ...result,
      provider_id: result.provider_id || 0,
      version_id: result.version_id || 0
    } as Category;
  }
};

export default categoryService; 